import React, { useState, useEffect } from 'react';
import Button from '../../common/Button/Button';
// import '../../common/selectedPopup.css';
import './EditEnquiryPopup.css'; // Assuming you have a CSS file for styling

const EditEnquiryPopup = ({ enquiry, onSave, onClose }) => {
  const [formData, setFormData] = useState({
    id: enquiry.id || '',
    enquiryID: enquiry.enquiryID || '',
    buyerName: enquiry.buyerName || '',
    date: enquiry.date ? new Date(enquiry.date).toISOString().substr(0, 10) : '',
    description: enquiry.description || '',
    status: enquiry.status || '',
    emailID: enquiry.emailID || '',
    phoneNumber: enquiry.phoneNumber || '',
    city: enquiry.city || '',
    state: enquiry.state || '',
    quotationFor: enquiry.quotationFor || '',
    productType: enquiry.productType || '',
    categoryID: enquiry.categoryID || '',
    note: enquiry.note || '',
    attachment: enquiry.attachment || null,
    attachmentName: enquiry.attachmentName || '',
  });
  const [category, setCategory] = useState([]);
  const [categorylist, setCategoryList] = useState([]);
  const [editEnquiry, setEditEnquiry] = useState({});


  const [attributes, setAttributes] = useState(
    (enquiry.EnquiryAttributes || enquiry.attributes)?.map(attr => ({
      id: attr.id,
      name: attr.attributeName || attr.name,
      value: attr.attributeValue || attr.value
    })) || []
  );

  React.useEffect(() => {
    setAttributes(
      (enquiry.EnquiryAttributes || enquiry.attributes)?.map(attr => ({
        id: attr.id,
        name: attr.attributeName || attr.name,
        value: attr.attributeValue || attr.value
      })) || []
    );
  }, [enquiry]);

  React.useEffect(() => {
    console.log('EditEnquiryPopup enquiry prop:', enquiry);
    console.log('Initial attributes state:', attributes);
  }, []);

  // Attachment state
  const [attachment, setAttachment] = useState(null);
  const [currentAttachment, setCurrentAttachment] = useState(enquiry.attachment);
  const [removeAttachment, setRemoveAttachment] = useState(false);
  const [fileError, setFileError] = useState('');

  // Keep currentAttachment in sync with enquiry.attachment
  useEffect(() => {
      setCurrentAttachment(enquiry.attachment);
      
      setAttachment(null); // Reset file input
      setRemoveAttachment(false); // Reset remove flag
      setFormData(prev => ({
        ...prev,
        attachment: enquiry.attachment || null,
        attachmentName: enquiry.attachmentName || '',
      }));
    }, [enquiry.attachment, enquiry.attachmentName, enquiry]);
  // Get the full URL for the attachment
  const getAttachmentUrl = (attachmentPath) => {
    if (!attachmentPath) return null;
    // If it's already a full URL, return as is
    if (attachmentPath.startsWith('http')) {
      return attachmentPath;
    }
    // If it's a relative path, construct the full URL
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    return `${baseUrl}${attachmentPath}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAttributeChange = (index, field, value) => {
    const newAttributes = [...attributes];
    newAttributes[index] = {
      ...newAttributes[index],
      [field]: value
    };
    setAttributes(newAttributes);
  };

  const addAttribute = () => {
    setAttributes([...attributes, { name: '', value: '' }]);
  };

  const removeAttribute = (index) => {
    setAttributes(attributes.filter((_, i) => i !== index));
  };
  
    const handleFileChange = (e) => {
    const file = e.target.files[0];
    const maxSize = 10 * 1024 * 1024; // 10MB
    const allowedTypes = [
        "image/jpeg", "image/png", "image/gif",
        "application/pdf", "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/plain"
    ];
    const isAllowedType = allowedTypes.includes(file?.type);

    if (file) {
        if (!isAllowedType) {
            setFileError('Unsupported file type. Allowed: JPEG, PNG, GIF, PDF, DOC, DOCX, XLSX, TXT.');
            setAttachment(null);
            e.target.value = ""; // Reset file input
            return;
        }
        if (file.size > maxSize) {
            setFileError('File size exceeds 10MB limit. Please select a smaller file.');
            setAttachment(null);
            e.target.value = ""; // Reset file input
            return;
        }
        setAttachment(file);
        setRemoveAttachment(false);
        setFileError('');
    }
  };

  // Handle attachment removal
  const handleRemoveAttachment = () => {
    setAttachment(null);
    setCurrentAttachment(null);
    setRemoveAttachment(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Log attributes before saving
    console.log('Submitting attributes:', attributes);

    const formDataToSend = new FormData();

    // Append all form data
    Object.keys(formData).forEach(key => {
      formDataToSend.append(key, formData[key]);
    });

    // Append attributes
    // const sanitizedAttributes = attributes.map(attr => ({
    //   name: String(attr.name),
    //   value: String(attr.value)
    // }));
    // formDataToSend.append('attributes', JSON.stringify(sanitizedAttributes));

    formDataToSend.append('attributes', JSON.stringify(attributes.map(attr => ({
      id: attr.id,
      attributeName: attr.name,
      attributeValue: attr.value
    }))));

    // Handle attachment
    if (attachment) {
      formDataToSend.append('attachment', attachment);
    }

    if (removeAttachment) {
      formDataToSend.append('removeAttachment', 'true');
    }

    onSave({
      ...formData,
      EnquiryAttributes: attributes.map(attr => ({
        ...attr,
        id: attr.id,
        attributeName: attr.name,
        attributeValue: attr.value
      })),
      attachment: attachment,
      removeAttachment: removeAttachment
    });
  };

  return (
    <div className="popup">
      <div className="popup-content">
        <div className="popup-header">
          <h3>Edit Enquiry</h3>
          <Button onClick={onClose} className="close-btn top-right" title="Close">×</Button>
        </div>
        <form className="popup-body" onSubmit={handleSubmit}>
          <div className="edit-popup-grid">
            {/* Displaying and editing Enquiry details section */}
            <div className="attributes-section">
              <div className="attributes-table">
                <table className="attributes-table">
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th>Value</th>
                      <th>Description</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><label htmlFor="enquiryID">Enquiry ID</label></td>
                      <td><input type="text" id="enquiryID" name="enquiryID" value={formData.enquiryID} disabled /></td>
                      <td><label htmlFor="buyerName">Buyer Name</label></td>
                      <td><input type="text" id="buyerName" name="buyerName" value={formData.buyerName} onChange={handleChange} required /></td>
                    </tr>
                    <tr>
                      <td><label htmlFor="date">Date</label></td>
                      <td><input type="date" id="date" name="date" value={formData.date} onChange={handleChange} required /></td>
                      <td><label htmlFor="status">Status</label></td>
                      <td>
                        <select id="status" name="status" value={formData.status} onChange={handleChange}>
                          <option value="Pending">Pending</option>
                          <option value="Closed">Closed</option>
                          <option value="Cancelled">Cancelled</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td><label htmlFor="emailID">Email ID</label></td>
                      <td><input type="email" id="emailID" name="emailID" value={formData.emailID} onChange={handleChange} /></td>
                      <td><label htmlFor="phoneNumber">Phone Number</label></td>
                      <td><input type="tel" id="phoneNumber" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} /></td>
                    </tr>
                    <tr>
                      <td><label htmlFor="city">City</label></td>
                      <td><input type="text" id="city" name="city" value={formData.city} onChange={handleChange} /></td>
                      <td><label htmlFor="state">State</label></td>
                      <td><input type="text" id="state" name="state" value={formData.state} onChange={handleChange} /></td>
                    </tr>
                    <tr>
                      <td><label htmlFor="quotationFor">Quotation For</label></td>
                      <td><input type="text" id="quotationFor" name="quotationFor" value={formData.quotationFor} onChange={handleChange} /></td>
                      <td><label htmlFor="categoryID">Category</label></td>
                      <td>
                        <select
                          name="category"
                          value={category?.id || ''}
                          onChange={(e) => {
                              const selectedCategory = categorylist.find(
                                  (cat) => cat.id === parseInt(e.target.value)
                              );
                              setCategory(selectedCategory);
                              setEditEnquiry({
                                  ...editEnquiry,
                                  cat_Id: selectedCategory?.id || null,
                              });
                          }}
                      >
                          <option value="" disabled>
                              Select a category
                          </option>
                          {categorylist.map((cat) => (
                              <option key={cat.id} value={cat.id}>
                                  {cat.name}
                              </option>
                          ))}
                      </select>
                      </td>
                    </tr>
                    <tr>
                      <td><label htmlFor="description">Subject</label></td>
                      <td colSpan="3">
                        <textarea id="description" name="description" value={formData.description} onChange={handleChange} rows={3} style={{ width: '100%' }} disabled/>
                      </td>
                    </tr>
                    <tr>
                      <td><label htmlFor="note">Note</label></td>
                      <td colSpan="3">
                        <textarea id="note" name="note" value={formData.note} onChange={handleChange} rows={3} style={{ width: '100%' }} />
                      </td>
                    </tr>
                    <tr>
                      <td><label htmlFor="attachment">Attachment</label></td>
                      <td colSpan="3">
                        {currentAttachment && !removeAttachment ? (
                          <div className="attachment-preview">
                            {/* <p><strong>Current Attachment:</strong></p> */}
                            <a href={getAttachmentUrl(currentAttachment)} target="_blank" rel="noopener noreferrer">
                              {currentAttachment.split('/').pop()}
                            </a>
                            <Button
                              type="button"
                              onClick={handleRemoveAttachment}
                              className="remove-attachment-btn"
                              title="Remove Attachment"
                            >
                              X
                            </Button>
                          </div>
                        ) : (
                          <div className="file-input-section">
                            <input
                              type="file"
                              id="attachment"
                              name="attachment"
                              onChange={handleFileChange}
                              accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xlsx"
                            />
                            {attachment && <p className="selected-file">Selected: {attachment.name}</p>}
                            <p className="file-info">
                              Supported formats: JPEG, PNG, GIF, PDF, DOC, DOCX, XLSX (Max size: 10MB)
                            </p>
                          </div>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Displaying and editing attributes */}
            <div className="attributes-section">
              <div className="attributes-header">
                <label>Attributes</label>
                <Button type="button" onClick={addAttribute} className="add-attribute-btn" title="Add Attribute">
                  + Add Attribute
                </Button>
              </div>
              <div className="attributes-table">
                {attributes.length > 0 ? (
                  <table>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Value</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {attributes.map((attr, index) => (
                        <tr key={attr.id || index}>
                          <td>
                            <input
                              type="text"
                              value={attr.name}
                              onChange={(e) => handleAttributeChange(index, 'name', e.target.value)}
                              placeholder="Attribute Name"
                              required
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              value={attr.value}
                              onChange={(e) => handleAttributeChange(index, 'value', e.target.value)}
                              placeholder="Attribute Value"
                              required
                            />
                          </td>
                          <td>
                            <Button
                              type="button"
                              onClick={() => removeAttribute(index)}
                              className="remove-attribute-btn"
                              title="Remove"
                            >
                              ×
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p className="no-attributes">No attributes added yet</p>
                )}
              </div>
            </div>
          </div>

          {/* Buttons section */}
          <div className="popup-footer">
            <Button type="submit" className="save-btn" title="Save">
              Save
            </Button>
            <Button onClick={onClose} className="cancel-btn" title="Cancel">
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEnquiryPopup;
